import { hasAnyPricedInputLine } from './price';

/**
 * Prédicats NOMMÉS du mécanisme générique de visibilité conditionnelle du DynamicForm
 * (`meta.visible_when` / `meta.hidden_when` avec `{ field, predicate }`, en complément de la
 * forme égalité `{ field, value }`). Le schéma TypeBox reste sérialisable (Swagger) : il ne
 * référence que le NOM du prédicat ; l'implémentation vit ici, côté shared, à côté des helpers
 * métier qu'elle réutilise. Le prédicat reçoit la valeur COURANTE du champ référencé par
 * `field` (watch réactif react-hook-form) et renvoie si la condition est remplie.
 */
export enum FormVisibilityPredicate {
  /** Au moins un élément — notamment les plages hebdomadaires d'une disponibilité. */
  HAS_ITEMS = 'HAS_ITEMS',
  /** Au moins une ligne de prix renseignée (type choisi ≠ NONE) — cf. hasAnyPricedInputLine. */
  HAS_PRICED_LINE = 'HAS_PRICED_LINE',
  /** Nombre strictement positif — notamment une fréquence de créneaux configurée (≠ 0). */
  IS_POSITIVE_NUMBER = 'IS_POSITIVE_NUMBER',
  /** Valeur renseignée (ni absente, ni nulle, ni chaîne vide) — ex. un type de paiement choisi. */
  IS_DEFINED = 'IS_DEFINED',
}

export const FORM_VISIBILITY_PREDICATES: Record<FormVisibilityPredicate, (value: unknown) => boolean> = {
  [FormVisibilityPredicate.HAS_ITEMS]: (value: unknown): boolean => Array.isArray(value) && value.length > 0,
  [FormVisibilityPredicate.HAS_PRICED_LINE]: hasAnyPricedInputLine,
  [FormVisibilityPredicate.IS_POSITIVE_NUMBER]: (value: unknown): boolean => Number(value) > 0,
  [FormVisibilityPredicate.IS_DEFINED]: (value: unknown): boolean =>
    value !== undefined && value !== null && value !== '',
};
